import ViewModuleOutlinedIcon from "@mui/icons-material/ViewModuleOutlined";
import { Grid, Typography } from "@mui/material";
import { useState } from "react";
import Hospitalization from "./Hospitalization";
import "./InpatientNew.css";
import Surgery from "./Surgery";
// import WardBoard from "./WardBoard";

const STATUS_LEGEND = [
  { key: "critical", label: "Critical" },
  { key: "stable", label: "Stable" },
  { key: "monitoring", label: "Monitoring" },
  { key: "isolation", label: "Isolation" },
];

const InpatientNew = ({ setSelectedTab, selectedVet }) => {
  const [activeTab, setActiveTab] = useState("Hospitalization");
  const [viewMode, setViewMode] = useState("Bucket");
  const [admissionModVsble, setAdmissionModVsble] = useState(false);

  const handleChangeTab = (tab) => {
    setActiveTab(tab);
  };

  return (
    <>
      <Grid container spacing={1}>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <div className="back-white pv10 ph15 br5">
            <div className="flex-row-between-align-center">
              {/* Left: title + new admission */}
              <div className="flex-row-ali-cen" style={{ gap: 12 }}>
                <Typography className="font-bold fs16 blue-color">
                  Inpatient
                </Typography>
                {/* <CustomButton
                  text="+ New Admission"
                  smallBtn
                  onClick={() => setAdmissionModVsble(true)}
                /> */}
              </div>

              {/* Right: Ward Board / Bucket View toggle + status legend */}
              <div className="inpatient-header-right">
                <div className="inpatient-status-legend">
                  {STATUS_LEGEND.map((item) => (
                    <div
                      key={item.key}
                      className={`inpatient-status-pill ${item.key}`}
                    >
                      <span className="inpatient-status-pill-dot" />
                      {item.label}
                    </div>
                  ))}
                </div>
                <div
                  className="flex-row-ali-cen br5"
                  style={{
                    border: "1px solid #e0e0e0",
                    borderRadius: 6,
                    overflow: "hidden",
                  }}
                >
                  {/* <button
                  onClick={() => setViewMode("Ward")}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 4,
                    padding: "5px 12px",
                    border: "none",
                    borderRight: "1px solid #e0e0e0",
                    background: viewMode === "Ward" ? "#e8eaf6" : "#fff",
                    color: viewMode === "Ward" ? "#283593" : "#616161",
                    cursor: "pointer",
                    fontSize: 13,
                    fontWeight: viewMode === "Ward" ? 600 : 400,
                  }}
                >
                  <TableChartOutlinedIcon style={{ fontSize: 16 }} />
                  Ward Board
                </button> */}
                  <button
                    onClick={() => setViewMode("Bucket")}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 4,
                      padding: "5px 12px",
                      border: "none",
                      background: viewMode === "Bucket" ? "#e8eaf6" : "#fff",
                      color: viewMode === "Bucket" ? "#283593" : "#616161",
                      cursor: "pointer",
                      fontSize: 13,
                      fontWeight: viewMode === "Bucket" ? 600 : 400,
                    }}
                  >
                    <ViewModuleOutlinedIcon style={{ fontSize: 16 }} />
                    Bucket View
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Grid>
      </Grid>

      {/* <div className="w10Per">
        <CustomButton
          text="Surgery"
          onClick={() => handleChangeTab("Surgery")}
          tabOutlined
          yellowBtn={activeTab === "Surgery"}
        />
      </div>
      <div className="w5Per">
        <div className="flex-center">
          <div className="ver-bar-h30" />
        </div>
      </div>
      <div className="w10Per">
        <CustomButton
          text="Hospitalization"
          onClick={() => handleChangeTab("Hospitalization")}
          tabOutlined
          yellowBtn={activeTab === "Hospitalization"}
        />
      </div> */}

      {activeTab === "Surgery" && <Surgery selectedVet={selectedVet} />}
      {activeTab === "Hospitalization" && (
        <Hospitalization selectedVet={selectedVet} />
      )}
      {/* {activeTab === "WardBoard" && <WardBoard />} */}
    </>
  );
};

export default InpatientNew;
